import React, {useState, useEffect } from 'react';

// helpers
import AmplitudeHelperClass from '/src/lib/amplitudeHelper';
import { withBootstrapPlugin } from '/src/lib/helpers';

const amplitudeHelper = new AmplitudeHelperClass();



const planData = [
    {
        name: 'Discovery',
        description: 'For Global and Regional Investors, Corporates, and Institutions exploring Venture in Emerging Markets.',
        cta: 'Request access',
        features: [
            'Access our complete historical library of premium research reports',
            'Access our 9 quarterly premium report publications',
            'Research support from a dedicated analyst team',
            'Assigned personal account manager for direct assistance',
            'Invitation to exclusive, invite-only MAGNiTT private capital events'
        ]
    },
    {
        name: 'Professional',
        description: 'For Regional & International Operators with a local presence looking for access to the region\'s most accurate private capital data and intelligence.',
        cta: 'Contact Sales',
        features: [
            'Access to our comprehensive directories: Companies, funds, LPs & transactions',
            'Export structured company and transaction data for internal analysis and reporting',
            'Save custom searches for scouting startups, investors, and tracking funding activity',
            'Generate real-time charts and visualizations to incorporate into board and client presentations',
            'Assigned research analyst for virtual presentations on the latest reports',
            'A dedicated account manager and a customer success lead with a focus on client problem solving'
        ]
    },
    {
        name: 'Enterprise',
        description: 'For Governments, Corporates and Larger teams looking for a comprehensive access to the region\'s private capital data infrastructure.',
        cta: 'Customize Your Solution',
        features: [
            'Access full Professional platform capabilities and features for your organization',
            'Enable structured, multi-team access with enterprise-level controls',
            'Export data at expanded, enterprise-grade capacity',
            'Access our full research library with unlimited quota',
            'Engage our research team with priority support and expanded quota'
        ]
    }
]

const PlanBoxes = () => {

    const longestDescriptionLength = Math.max(...planData.map((plan) => plan.description.length));
    const [maxDescHeight, setMaxDescHeight] = useState('auto');

    useEffect(() => {
        const longestIndex = planData.findIndex(plan => plan.description.length === longestDescriptionLength);
        const elements = document.querySelectorAll('.plan-desc');
        const target = elements[longestIndex];
        if (!target) return;

        const updateHeight = () => {
            if (window.innerWidth <= 700) {
                setMaxDescHeight('auto');
            } else {
                setMaxDescHeight(`${target.offsetHeight}px`);
            }
        };

        const observer = new ResizeObserver(updateHeight);
        observer.observe(target);
        return () => {
            observer.disconnect();
        };
    }, []);

    const amplitudeTrack = (label) => {
        amplitudeHelper.trackEvent('Upgrade Clicked', {
            button_clicked: label
        });
    }

    const showContactForm = (plan) => {
        // "pricing-clicked-standard" // "pricing-clicked-business" // "pricing-clicked-enterprise"
        amplitudeTrack(`pricing-clicked-${plan.name.toLowerCase()}`);
        withBootstrapPlugin('modal', ($) => $("#contactFormModal").modal('show'));
    };

    return (
        <div className="row no-gutters justify-content-center">

            {planData.map((plan, i) => {
                const descBalance = Math.max(0, longestDescriptionLength - plan.description.length);
                return (
                    <div className={`pricing-plan-box  ${plan.name.toLowerCase()}`} key={`pricing-plan-${i}`}>
                        <div className="plan-details">
                            <div className="plan-header">
                                <h5>{plan.name}</h5>
                            </div>

                            <p className="plan-desc" style={{height: descBalance > 0 ? maxDescHeight : 'auto'}}>
                                {plan.description}
                            </p>

                            {/* action buttons */}
                            <a type="button"
                                className="btn btn-main btn-block btn-sm"
                                onClick={() => showContactForm(plan)}
                                // href="#contactForm" (for scroll to)
                            >
                                {plan.cta}
                            </a>

                            <p className="plan-features">What's included</p>
                            <ul className="features-list">
                                {plan.features.map((feature, f) => <li data-has-access={true} key={`feature-${i}-${f}`}>{feature}</li>)}
                            </ul>

                        </div>
                    </div>
                );
            })}

        </div>
    )

}

export default PlanBoxes;
